<template>
    <Component
        :is="component"
        :to="to"
        ref="root"
        :disabled="isButton ? disabled || loading : null"
        :type="isButton ? type : null"
        :class="[
            {
                relative:
                    !$attrs.class ||
                    (typeof $attrs.class === 'string' &&
                        !$attrs.class.includes('absolute')),
            },
            sizesClass,
        ]"
        class="flex items-center justify-center border border-white bg-white/20 text-white transition-all duration-300 before:absolute before:size-[calc(100%_+_2px)] before:transform-gpu before:rounded-full before:bg-gradient-button before:opacity-0 before:transition-opacity before:duration-500 enabled:hover:bg-white/50 enabled:active:border-transparent enabled:active:before:opacity-100 disabled:opacity-50">
        <AtomIcon
            name="arrow-right"
            :class="[
                {
                    '-rotate-90': rotation === 'top',
                    'rotate-90': rotation === 'bottom',
                },
                arrowClass,
            ]"
            class="relative" />
    </Component>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'

const root = useTemplateRef('root')
const props = defineProps({
    to: {
        /**
         * Выводит ссылку в виде кнопки
         */
        type: [String, null as unknown] as PropType<string | null>,
        default: null,
    },
    type: {
        /**
         * Тип кнопки
         */
        type: String as PropType<'button' | 'submit' | 'clear'>,
        default: 'button',
    },
    disabled: {
        /**
         * Перевод кнопки в неактивную, работает только если не передается ссылка
         */
        type: Boolean as PropType<boolean>,
        default: false,
    },
    loading: {
        /**
         * Показать лоадер
         * Перевод кнопки в неактивную, работает только если не передается ссылка
         */
        type: Boolean as PropType<boolean>,
        default: false,
    },
    sizesClass: {
        type: String as PropType<string>,
        default: 'size-12 rounded-full',
    },
    arrowClass: {
        type: String as PropType<string>,
        default: 'size-6',
    },
    rotation: {
        type: String as PropType<'top' | 'right' | 'bottom' | 'left'>,
        default: 'right',
    },
})

defineExpose({ root })
const component = computed(() => {
    return props.to ? resolveComponent('NuxtLink') : 'button'
})
const isButton = computed(() => {
    return component.value === 'button'
})
</script>
